import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Table, Pagination, Offcanvas, Button } from 'react-bootstrap'
import { FaPlus,FaEdit, FaTrash } from "react-icons/fa";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { ToastContainer, toast } from "react-toastify";
import DeleteModal from "../../components/common/DeleteModel";
import SubAdminFilter from "./SubAdminFilter";

const ManageAdmin = () => {
  const [show, setShow] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [categories, setCategories] = useState([]);
  const [roleid, setRoleid] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDt, setShowDt] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const navigate = useNavigate();
  const limit = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const statusRef = useRef("Select Status");
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };


  useEffect(() => {
    fetchData(currentPage, filters);
  }, [currentPage, filters]);

  const fetchData = async (page = 1, filters) => {
    const params = {
      ...filters,
      offset: (page - 1) * limit,
      limit: limit,
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) =>
          value !== "" && value !== undefined && value !== null
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    const encodedStatus =
      statusRef.current === "Select Status" ? "" : statusRef.current;
    try {
      const response = await APIServices.get(
        `/admin/admin_list?${queryString}`,
        headers
      );
      if (response?.status === 200) {
        const data1 = response?.data?.data || [];
        setAdminList(data1);
        setTotalCount(response?.data?.data?.length || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setAdminList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAdminList([]);
      setTotalCount(0);
    }
  };

  const handleStatusChange = async (subAdmin) => {
    const newStatus = subAdmin.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: subAdmin.id, status: newStatus };
      const res = await APIServices.post(
        `/admin/admin_status_update`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedFaqs = adminList.map((item) =>
          item.id === subAdmin.id ? { ...item, status: newStatus } : item
        );
        setAdminList(updatedFaqs);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const handleDeleteSubAdmin = async () => {
    try {
      if (selectedUser !== null) {
        const payload = { id: selectedUser };
        const res = await APIServices.post(
          `/admin/admin_delete`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          const updatedFaqs = adminList.filter((faq) => faq.id !== selectedUser);
          setAdminList(updatedFaqs);
          setSelectedUser(null);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
      setShowDt(false);
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="momList_inner todo_list_inner subAdmin_list_inner ">
        <div className="mom_header d-flex align-items-center justify-content-between mb-3">
          <h1 className="font_blue_18 font-600">{`Sub-Admin (${totalCount})`}</h1>

          <ul className="d-flex align-items-center mom_filter">
            <li
              className="d-flex align-items-center cursor-pointer"
              onClick={() => setShowFilter(true)}
            >
              Filter By{" "}
              <img
                src="/images/Sort.svg"
                className="img-fluid ms-2"
                alt="Sort"
              />
            </li>
            <li>
              <button
                className="btn red_button d-flex align-items-center"
                onClick={() => navigate("/admin/add-sub-admin")}
              >
                <FaPlus className="me-1" />
                Add Sub-Admin
              </button>
            </li>
          </ul>
        </div>

        <div className="todoList_table">
          <div className="table-responsive">
            <Table>
              <thead className="table-dark">
                <tr>
                  <th>Sr.No</th>
                  <th>Name</th>
                  <th>Username</th>
                  <th>Role</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                {adminList.map((user, index) => (
                  <tr key={user.id}>
                    <td>{(currentPage - 1) * limit + index + 1}</td>
                    <td>
                      {/* <Link to="/"> */}
                      <div className="d-flex align-items-center">

                        {
                          user?.profile_pic ?
                            <img
                              src={user.profile_pic}
                              className="img-fluid me-2 table_user"
                              alt={user.first_name}
                              onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                            />
                            :
                            <img src="/images/placeholder-img.jpg"
                              className='img-fluid me-2 table_user'
                              alt="default img"
                            />
                        }
                        <div>
                          <h3 className="font_blue_16 textTransform">{user.fullname}</h3>
                          <p className="font_blue_14">{user.email}</p>
                        </div>
                      </div>
                      {/* </Link> */}
                    </td>
                    <td>{user?.username}</td>
                    <td>{user.role_name}</td>
                    <td>{user.country_code ? user.country_code + "-" : ""}{user.mobile}</td>

                    <td>
                      <Form className="Switch_toggle">
                        <input
                          type="checkbox"
                          id={`switch-${user.id}`}
                          checked={user.status === "Active"}
                          onClick={() => handleStatusChange(user)}
                        />
                        <label
                          for="switch"
                          className="position-relative"
                          htmlFor={`switch-${user.id}`}
                        >
                          Toggle
                        </label>
                      </Form>
                    </td>

                    <td>
                      <ul className="d-flex align-items-center list-unstyled mb-0">
                        <li className="me-2">
                          <button
                            className="btn btn-sm btn-outline-success py-1"
                            onClick={() =>
                              navigate(`/admin/update-sub-admin/${user.id}`, {
                                state: { row: user },
                              })
                            }
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '36px',
                              height: '32px',
                              padding: '4px 8px'
                            }}
                            title="Edit Sub Admin"
                          >
                            <FaEdit size={14} />
                          </button>
                        </li>
                        <li>
                          <button
                            className="btn btn-sm btn-outline-danger py-1"
                            onClick={() => {
                              setSelectedUser(user.id);
                              setShowDt(true);
                            }}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '36px',
                              height: '32px',
                              padding: '4px 8px'
                            }}
                            title="Delete User"
                          >
                            <FaTrash size={14} />
                          </button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {showFilter && (
        <SubAdminFilter
          appliedFilters={filters}
          show={showFilter}
          onHide={() => setShowFilter(false)}
          onApplyFilter={(filterData) => {
            setFilters(filterData);
            setShowFilter(false);
          }}
          onClear={() => {
            setFilters({});
            setShowFilter(false);
          }}
        />
      )}
      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => setShowDt(false)}
        handledelete={handleDeleteSubAdmin}
      />
      <ToastContainer />
    </>
  );
}

export default ManageAdmin